import React from 'react';
import { Box, Center, HStack, VStack, Skeleton } from 'native-base';
import { H2 } from '~/shared/Typography';
import ItemCard, { ItemCardSkeleton } from '~/shared/ItemCard';
import { BuilderRewards } from '../Reward';
import { useAppSettings, useTheme } from '@springbig/shared';
import { Panel } from '~/shared/Theme';

export type RewardSliderBoxProps = {
    rewards: BuilderRewards;
    redeemIsLoading: boolean;
    handleAcceptRedeemReward: (id: number, title?: string) => void;
};

const RewardSliderBox = ({
    rewards,
    redeemIsLoading,
    handleAcceptRedeemReward
}: RewardSliderBoxProps) => {

    const {
        rewards: rewardsSettings,
        style: { rewards: { rewardSliderBox = {}, rewardItemCaption = {} } = {} } = {}
    } = useAppSettings();

    const rewarsCount = Object.keys(rewards).length;

    return (
        <Box w={'clamp(320px, 100vw, 480px)'}>
            <VStack space={4}>
                { Object.entries(rewards).map(([key, value], index) => {

                    const processKey = key.split('-')[1];
                    const isCentered = value.length > 1 ? false : rewardsSettings?.showInCenter;

                    return (
                        <Box
                            key={key}
                            overflowX={'hidden'}
                            w={'100%'}
                            {...rewardSliderBox}
                            borderBottomWidth={index === (rewarsCount - 1) ? 0 : rewardSliderBox.borderBottomWidth}
                        >
                            <H2
                                px={4}
                                text={'rewards.title_points_rewards'}
                                textValues={[`${processKey}`]}
                                textAlign={isCentered ? 'center' : 'left'}
                            />
                            <Panel
                                row
                                space={4}
                                overflowX={'auto'}
                                justifyContent={isCentered ? 'center' : 'normal'}
                            >
                                { value.map(reward => {

                                    return <ItemCard
                                        key={reward?.id}
                                        loadingComponent={false}
                                        handleCallback={handleAcceptRedeemReward}
                                        isDisabled={redeemIsLoading}
                                        id={reward.id}
                                        title={reward.name}
                                        imageUrl={reward.images.length > 0 ? reward.images[0].url : undefined}
                                        captionStyle={rewardItemCaption}
                                    />;
                                })}
                            </Panel>
                        </Box>
                    );
                })}
            </VStack>
        </Box>
    );
};

export const RewardSliderBoxSkeleton = () => {

    const {
        panel,
    } = useTheme();

    return (
        <Center w="100%">
            <Skeleton.Text lines={1} alignItems="center" pl={4} pr={10} py={5} />
            <HStack bg={panel}>
                <ItemCardSkeleton />
                <ItemCardSkeleton />
            </HStack>
        </Center>
    );
};


export default RewardSliderBox;
